module.exports = __webpack_public_path__ + "static/media/icon-plc.67350012.jpg";